export default __webpack_public_path__ + "static/media/8.8bfd9f02.webp";